import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-share-light",
  "use": "ico-share-light-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico-share-light\">\n  <path id=\"ico-share-light_Path_1561\" data-name=\"Path 1561\" d=\"M18.857,42.286a5.143,5.143,0,1,0-5.143-5.143,5.03,5.03,0,0,0,.037.637L8.711,40.3a5.143,5.143,0,1,0,0,7.4l5.041,2.518a4.972,4.972,0,0,0-.037.638,5.147,5.147,0,1,0,1.575-3.7l-5.041-2.518a5.437,5.437,0,0,0,0-1.275l5.041-2.518A5.1,5.1,0,0,0,18.857,42.286Z\" transform=\"translate(0 -32)\" fill=\"#fff\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol